module.exports = __webpack_public_path__ + "static/fonts/AkkuratPro-Regular.d92211b.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/AkkuratPro-Regular.woff
// module id = 4+e1
// module chunks = 1